// extracted by mini-css-extract-plugin
export default {"formContainer":"AddPatient_formContainer__7D2e5","formBtn":"AddPatient_formBtn__CGVs3"};